// extracted by mini-css-extract-plugin
export default {"root":"LoanStatusConfigCard_root__3aSm-","icons":"LoanStatusConfigCard_icons__Iv7Qi","info":"LoanStatusConfigCard_info__S6QG+"};